import { useModal } from '@billy/design-system'
import { useCallback, useState } from 'react'

import { LegalMentionsSettings } from '@features/invoicingSettings/types/legalSettings/legalMentionsSettings'

import { ModalId } from '../../../../../../../enums/modalId'
import { LegalMentionsType } from '../enums/legalMentionsType'
import { getLegalMentionsDefaultValues } from '../utils/getLegalMentionsDefaultValues'

export interface UseInvoiceSettingsModalsLegalMentionsResult {
  defaultValues: LegalMentionsSettings
  onSubmit: (legalMentionsDetails: LegalMentionsSettings) => void
  openModal: (variant: LegalMentionsType, formLegalMentionsDetails: LegalMentionsSettings) => void
  legalMentionsDetails?: LegalMentionsSettings
  shouldUpdateForm: boolean
  variant: LegalMentionsType
}

export const useInvoiceSettingsModalsLegalMentions = (): UseInvoiceSettingsModalsLegalMentionsResult => {
  const [shouldUpdateForm, setShouldUpdateForm] = useState<boolean>(false)
  const [legalMentionsDetails, setLegalMentionsDetails] = useState<LegalMentionsSettings | undefined>()
  const [variant, setVariant] = useState(LegalMentionsType.LatePaymentPenaltyRate)

  const { open: openLegalMentionsModal, close: closeLegalMentionsModal } = useModal(ModalId.LegalMentionsModal)

  const legalMentionsDefaultValues = getLegalMentionsDefaultValues()

  const handleSubmit = useCallback(
    (updatedLegalMentionsDetails: LegalMentionsSettings) => {
      setLegalMentionsDetails(updatedLegalMentionsDetails)
      setShouldUpdateForm(true)
      closeLegalMentionsModal()
    },
    [closeLegalMentionsModal],
  )

  const handleOpen = useCallback(
    (modalVariant: LegalMentionsType, formLegalMentionsDetails: LegalMentionsSettings) => {
      setVariant(modalVariant)
      setLegalMentionsDetails(formLegalMentionsDetails)
      setShouldUpdateForm(false)
      openLegalMentionsModal()
    },
    [openLegalMentionsModal],
  )

  return {
    defaultValues: legalMentionsDetails ?? legalMentionsDefaultValues,
    openModal: handleOpen,
    onSubmit: handleSubmit,
    legalMentionsDetails,
    shouldUpdateForm,
    variant,
  }
}
